import * as types from '@/store/types';
import accountsApi from '@/api/accounts.api';

export default {
    state: {
        unapprovedCount: 0,
        timer: null,
    },
    getters: {
        [types.APPROVE_UNAPPROVED_COUNT]: (state) => {
            return state.unapprovedCount;
        },
    },
    mutations: {
        [types.APPROVE_SET_UNAPPROVED_COUNT]: async (state, count) =>  {
            state.unapprovedCount = count;
        },
        [types.APPROVE_SET_TIMER_UNAPPROVED_COUNT]: async (state, timer) =>  {
            state.timer = timer;
        },
        [types.APPROVE_UNSET_TIMER_UNAPPROVED_COUNT]: async (state) =>  {
            state.timer = null;
        },
    },
    actions: {
        [types.APPROVE_START_TIMER_UNAPPROVED_COUNT]: (context) => {
            if (context.getters[types.AUTH_HAS_PERMISSION_APPROVE_AGENTS]) {
                context.dispatch(types.APPROVE_QUERY_UNAPPROVED_COUNT);
                let timer = setInterval(() => {
                    context.dispatch(types.APPROVE_QUERY_UNAPPROVED_COUNT);
                }, 5000);
                context.commit(types.APPROVE_SET_TIMER_UNAPPROVED_COUNT, timer);
            }
        },
        [types.APPROVE_END_TIMER_UNAPPROVED_COUNT]: (context) => {
            if (context.state.timer) {
                clearTimeout(context.state.timer);
                context.commit(types.APPROVE_UNSET_TIMER_UNAPPROVED_COUNT);
            }
        },
        [types.APPROVE_QUERY_UNAPPROVED_COUNT]: async  (context) => {
            if (context.getters[types.AUTH_HAS_PERMISSION_APPROVE_AGENTS]) {
                const count = await accountsApi.unapprovedCount();
                context.commit(types.APPROVE_SET_UNAPPROVED_COUNT, count);
            }
        }
    }
};
